import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { PinAuthService } from '../services/auth/pin-auth.service';

/**
 * Гуард, который проверяет, авторизован ли пользователь по пин-коду.
 * Применяется только для вошедших пользователей: если нет валидного токена,
 * пин-код не требуется и доступ разрешается.
 * Если пин-код установлен, но пользователь не авторизован - перенаправляет на страницу ввода пин-кода.
 * Если пин-код только что установлен (первый вход) - пропускает без повторного ввода.
 */
export const pinAuthGuard: CanActivateFn = async () => {
  const oauthService = inject(OAuthService);
  const pinAuthService = inject(PinAuthService);
  const router = inject(Router);

  if (!oauthService.hasValidAccessToken()) {
    return true;
  }

  const isPinSet = await pinAuthService.isPinSet();

  if (!isPinSet) {
    return router.createUrlTree(['/pin-setup']);
  }

  if (pinAuthService.isAuthenticated()) {
    return true;
  }

  if (pinAuthService.wasJustSetup()) {
    pinAuthService.clearJustSetupFlag();
    return true;
  }

  return router.createUrlTree(['/pin-auth']);
};
